var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm6.968 8c0 3.829-3.1 6.968-6.968 6.968A6.967 6.967 0 011.032 8c0-3.829 3.1-6.968 6.968-6.968 3.829 0 6.968 3.1 6.968 6.968zm-4.803 2.848l-2.62-1.903a.39.39 0 01-.158-.313V3.484c0-.213.174-.387.387-.387h.452c.213 0 .387.174.387.387v4.72l2.274 1.654c.174.126.21.368.084.542l-.264.364a.39.39 0 01-.543.084z",
    fill: "#3A50F3"
  })));
}

export default __webpack_public_path__ + "./fonts/clock.3725dc664e71c07ef8099e0a3491e1a4.svg";
export { SvgClock as ReactComponent };